let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9UUoJ")).then(() => parcelRequire('aL23w'));